<script>
    import { Link } from "svelte-routing";
    </script>
<nav class="navbar navbar-expand-lg bg-body-tertiary">
  <div class="container-fluid">
    <a class="navbar-brand" href="https://pos-x.vercel.app/">POS-X Web App</a>
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
     <i class="fas fa-ellipsis-v"></i>
    </button>
    <div class="collapse navbar-collapse justify-content-end" id="navbarNav">
      <ul class="navbar-nav justify-content-end">
        <li class="nav-item">
          <Link class="nav-link active" aria-current="page" to="/">Home</Link>
        </li>
       <li class="nav-item">
          <Link class="nav-link active" aria-current="page" to="/about">About</Link>
        </li>
       <li class="nav-item">
          <Link class="nav-link active" aria-current="page" to="/shop">Shop</Link>
        </li>
       <li class="nav-item">
          <Link class="nav-link active" aria-current="page" to="/privacy">Privacy</Link>
        </li>
       <li class="nav-item">
          <Link class="nav-link active" aria-current="page" to="/contact">Contact</Link>
        </li>
       <li class="nav-item">
          <a class="nav-link active" aria-current="page" href="https://axcora.my.id/pos-x">Login</a>
        </li>
      </ul>
    </div>
  </div>
</nav>
